import { IAcademyPhone } from '@sdk/contracts';

import { PurpleIconWrapper } from '../../../shared/WidgetShared.styles';

import { TitleWrapper } from './PhoneRow.styles';

import { Icon } from '@/components/Icon';

export const PhoneRow: React.FC<IAcademyPhone> = ({ prefix, number, info }) => {
  const fullNumber = `${prefix ?? ''}${number ?? ''}`.replace(/\s+/g, '');
  return (
    <TitleWrapper>
      <PurpleIconWrapper>
        <Icon i="Phone" color="purple7" />
      </PurpleIconWrapper>
      <a href={`tel:${fullNumber}`}>
        {prefix ?? ''} {number ?? ''} {info ?? ''}
      </a>
    </TitleWrapper>
  );
};
